import { PatientInformation } from "~/providers/components";

export const OngoingPatientInformation = () => <PatientInformation />;
